import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicToggle = ({
  defaultClass,
  toggledClass,
  defaultCaption,
  toggledCaption,
  handler,
  value,
  selected,
}) => {
  const handleToggleClick = () => {
    handler(value);
  };

  const toggled = selected === value;
  const classes = defaultClass + ' ' + (toggled ? toggledClass : '');

  return (
    <button className={classes} onClick={handleToggleClick}>
      {toggled ? toggledCaption : defaultCaption}
    </button>
  );
};

BasicToggle.propTypes = {
  defaultClass: PropTypes.string,
  toggledClass: PropTypes.string,
  defaultCaption: PropTypes.string,
  toggledCaption: PropTypes.string,
  handler: PropTypes.func,
  value: PropTypes.string,
  selected: PropTypes.string,
};

export default BasicToggle;
